module.exports = __webpack_public_path__ + "static/pr-op-management@2x-bc3820bb4c54c96895135593753f7503.png";